import stepsNone from './steps-none.png' ;

export default stepsNone;
